import { supabase } from '../supabase';
import { Exporter } from '../utils/types';

export const getAllExporters = async (): Promise<Exporter[]> => {
  try {
    const { data, error } = await supabase
      .from('exporters')
      .select(
        `
      *,
      species:exporters_species(
        id,
        species_id,
        species:species_id(id, name, excel_name)
      )
    `
      )
      .order('id', { ascending: true });

    if (error) {
      throw new Error(error.message);
    }

    // Usar los datos tal como vienen
    return data as Exporter[];
  } catch (error) {
    console.error('Error fetching exporters:', error);
    throw error;
  }
};

export const createExporter = async (
  exporter: Omit<Exporter, 'id' | 'created_at'>
): Promise<Exporter> => {
  try {
    const { data, error } = await supabase
      .from('exporters')
      .upsert(exporter)
      .select()
      .single();

    if (error) {
      throw new Error(error.message);
    }

    return data as Exporter;
  } catch (error) {
    console.error('Error creating exporter:', error);
    throw error;
  }
};

export const updateExporter = async (
  id: number,
  exporter: Partial<Exporter>
): Promise<Exporter> => {
  try {
    const { data, error } = await supabase
      .from('exporters')
      .update(exporter)
      .eq('id', id)
      .single();

    if (error) {
      throw new Error(error.message);
    }

    return data as Exporter;
  } catch (error) {
    console.error('Error updating exporter:', error);
    throw error;
  }
};

export const deleteExporter = async (id: number): Promise<void> => {
  try {
    const { error } = await supabase.from('exporters').delete().eq('id', id);

    if (error) {
      throw new Error(error.message);
    }
  } catch (error) {
    console.error('Error deleting exporter:', error);
    throw error;
  }
};

export const getExporterById = async (id: number): Promise<Exporter> => {
  try {
    const { data, error } = await supabase
      .from('exporters')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      throw new Error(error.message);
    }

    return data as Exporter;
  } catch (error) {
    console.error('Error fetching exporter:', error);
    throw error;
  }
};

export const uploadExporterLogo = async (file: File): Promise<string> => {
  const fileExt = file.name.split('.').pop()?.toLowerCase() || 'png';
  const fileName = `${Date.now()}-${Math.random()
    .toString(36)
    .substring(7)}.${fileExt}`;

  const { error } = await supabase.storage
    .from('exporter-logos')
    .upload(fileName, file, { contentType: file.type });

  if (error) {
    throw new Error(error.message);
  }

  const { data } = supabase.storage
    .from('exporter-logos')
    .getPublicUrl(fileName);

  return data.publicUrl;
};

export async function getExporterIdByExcelName(
  name: string
): Promise<number | null> {
  try {
    const { data, error } = await supabase
      .from('exporters')
      .select('id')
      .eq('id', name)
      .single();

    if (error) throw error;
    return data?.id || null;
  } catch (error) {
    console.error('Error getting exporter:', error);
    return null;
  }
}
